import React from 'react'

import { Space, Heading4, Join } from '@gousto-internal/citrus-react'

import { RecipeTagGroup } from '@library/api-menu-experience/src/interfaces/recipe'

import { LoadingSkeleton } from 'routes/Menu/components/Detail/LoadingSkeleton'

import { RecipeAttributesPills } from './RecipeAttributesPills'

type RecipeAttributesProps = {
  tags?: RecipeTagGroup['tags']
  loading: boolean
}

export const RecipeAttributes = ({ tags, loading }: RecipeAttributesProps) => (
  <Join with={<Space size={2} />}>
    <Heading4>Recipe details</Heading4>
    <RecipeAttributesPills tags={tags} loading={loading} />
    {loading && (
      <>
        <LoadingSkeleton style={{ height: '10px', width: '50%', marginBottom: '15px' }} />
        <LoadingSkeleton style={{ height: '10px', width: '55%' }} />
      </>
    )}
  </Join>
)
